import calendarIcon from '../svg/calendar.svg';
export const size = pixels => `${pixels / 16}rem`;

export default {
  selectedColor: '#608fc9',
  borderColor: '#ededed',
  dayColor: '#f2f5f7',
  textColor: '#1c2a3b',
  calendarIcon
};
